const KEYS = [
  'title',
  'volume',
  'issue',
  'year',
  'month',
  'day',
  'period',
  'format',
  'reference',
  'partitioning',
  'published_date'
] as string[];

export default function() {
  return KEYS;
}
